import { Injectable } from '@angular/core';
import { GlobalEventDistributor } from 'src/globalEventDistributor';
import { Router } from '@angular/router';
import { Subscriber } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ProcessService {

    constructor(private globalEventDistributor: GlobalEventDistributor,
        private router: Router) {
        this.globalEventDistributor.subscriber.subscribe((action: any) => {
            this.process(action);
        });
    }


    public process(action: any) {
        switch (event.type) {
            case 'UNAUTHORIZED': {
                this.router.navigate(['gad']);
                break;
            }
            case 'AUTHORIZED': {
                this.router.navigate(['cup']);
                break;
            }
        }
    }
}